import React, { Component } from "react";
class PrivacyPolicyPopup extends Component {
    render() {
        return (
            <div className="privacyPopup">                
                <p class="copy" style={{marginBottom: '0'}}>Effective Date: 1/21/2025</p>
                <p class="copy" style={{marginTop: '0'}}>Last Updated: 1/21/2025</p>
                <p class="copy">
                </p><h2 id="Scope" class="bold subHeader">Scope</h2>
                <p></p>
                <p class="copy">
                    This Privacy Policy ("<span class="bold">Policy</span>") describes how Healthy Paws, a Chubb Company, and its
                    U.S.-based
                    affiliates ("<span class="bold">Healthy Paws</span>," "<span class="bold">we</span>," "<span class="bold">our</span>," or
                    "<span class="bold">us</span>") collects, uses, and discloses your information, including Personal Information,
                    when you
                    visit our websites, including <a href="https://www.healthypawspetinsurance.com" target="_blank">www.healthypawspetinsurance.com</a>
                    (the "<span class="bold">Sites</span>"), download our mobile application, or use any of our products or services
                    that link
                    to or otherwise reference this Policy (collectively, the "<span class="bold">Services</span>"). This policy does
                    not apply
                    to <a href="https://www.chubb.com" target="_blank">www.chubb.com</a> nor to any non-Healthy Paws websites or
                    mobile
                    applications that you may access via the Services. Those websites and services are governed by the privacy
                    policies
                    that appear on those sites and applications. Depending on your relationship with us, you may receive other
                    privacy
                    notices from us providing additional detail about our privacy practices. If you are a California resident,
                    please
                    see the <a href="#AdditionalNoticeToCaliforniaResidents" class="bold">Additional Notice to California
                        Residents</a> below for more
                    information.
                </p>
                <p class="copy">
                    Your use of the Services is subject to this Policy and the Healthy Paws <a href="/legal" target="_blank">Terms
                        and Conditions</a>, including applicable terms of limitations on liability and the resolution of disputes.
                </p>
           
                <p class="copy">
                </p><h2 class="bold subHeader">Table of Contents</h2>
                <p></p>
                <p class="copy">
                    <a class="purpleLink copy" href="#Scope">Scope</a><br />
                    <a class="purpleLink copy" href="#PersonalInformationWeCollect">Personal Information We Collect</a><br />
                    <a class="purpleLink copy" href="#HowWeUsePersonalInformation">How We Use Personal Information</a><br />
                    <a class="purpleLink copy" href="#HowWeMayDisclosePersonalInformation">How We May Disclose Personal Information</a><br />
                    <a class="purpleLink copy" href="#HowWeCollectAndUseSocialSecurityNumbers">How We Collect and Use Social Security Numbers</a><br />
                    <a class="purpleLink copy" href="#CookiesAndOtherTrackingMechanisms">Cookies and Other Tracking Mechanisms</a><br />
                    <a class="purpleLink copy" href="#YourCookieAndMarketingChoices">Your Cookie and Marketing Choices</a><br />
                    <a class="purpleLink copy" href="#ChildrensInformation">Children's Information</a><br />
                    <a class="purpleLink copy" href="#ExternalLinks">External Links</a><br />
                    <a class="purpleLink copy" href="#BlogsAndOtherFeatures">Blogs and Other Features</a><br />
                    <a class="purpleLink copy" href="#ArtificialIntelligence">Artificial Intelligence</a><br />
                    <a class="purpleLink copy" href="#Security">Security</a><br />
                    <a class="purpleLink copy" href="#ChangesToThisPolicy">Changes to This Policy</a><br />
                    <a class="purpleLink copy" href="#ContactUs">Contact Us</a><br />
                    <a class="purpleLink copy" href="#Consent">Consent</a><br />
                    <a class="purpleLink copy" href="#AdditionalNoticeToCaliforniaResidents">Additional Notice to California Residents</a><br />
                </p>
                
                <p class="copy">
                </p><h2 id="PersonalInformationWeCollect" class="bold subHeader">Personal Information We Collect</h2>
                <p></p>
                <p class="copy">
                    We collect information that identifies, describes, or is reasonably capable of being associated with you
                    ("<span class="bold">Personal Information</span>"). Personal Information does not include publicly available
                    information, such as information lawfully made available from government records, information we have a
                    reasonable basis to
                    believe is lawfully made available to the general public by you or by widely distributed media, or by a person
                    to whom you have disclosed the information and not restricted it to a specific audience, or deidentified or
                    aggregated information.
                </p>
                <p class="copy">
                    As described below, we collect Personal Information directly from you, automatically through your use of the
                    Sites and Services, and from third-party sources. To the extent permitted by applicable law, we may combine the
                    information we collect from publicly available or third-party sources. The Personal Information we collect
                    varies based on your relationship with us.
                </p>

                <p class="copy guidelines">
                    <span class="bold">Personal Information We Collect Directly From You</span>
                </p>
                <p class="copy">
                    In order to access certain Services, we may collect Personal Information directly from you, including throughout
                    the quoting, application, or claims handling processes. The Personal Information you provide directly to us may
                    include:

                </p><ul class="blackdisc copy">
                    <li>
                        <span class="bold">Identifiers and Contact Information.</span> We may collect personal identifiers and
                        contact information such as your name, address, email address, phone number.
                    </li>
                    <li>
                        <span class="bold">Government-Issued Identifiers.</span> We also may collect information such as your
                        driver's license number, social security number, tax ID, or other government-issued identifiers.
                    </li>
                    <li>
                        <span class="bold">Account Details.</span> If you register an account with us, we collect information such
                        as your email, phone number, or user ID, and password used to login to your account.
                    </li>
                    <li>
                        <span class="bold">Policy or Claims Information.</span> This includes policy information, claim information,
                        including materials you submit as part of your claim, or other information you choose to provide us.
                    </li>
                    <li>
                        <span class="bold">Commercial Information.</span> We may also collect information about the products,
                        services, or coverage you purchase.
                    </li>
                    <li>
                        <span class="bold">Payment Information.</span> If you pay a bill, we may collect information necessary to
                        process your payment such as bank account information, billing address, and any other related information.
                    </li>
                    <li>
                        <span class="bold">Message Contents.</span> We may collect your messages, email contents, or any other
                        information you so choose to provide when interacting with our customer service or agents.
                    </li>
                    <li>
                        <span class="bold">Audio or Similar Information.</span> If you speak with our customer service team by
                        phone, we may collect a recording for quality assurance and training purposes.
                    </li>
                    <li>
                        <span class="bold">Preferences.</span> We may also collect information about the types of Services you use,
                        your communications preferences, wish lists and other preferences you may select in your account or profile.
                    </li>
                    <li>
                        <span class="bold">Other Information.</span> We also collect information when you complete online forms,
                        surveys, or leave us product reviews. We also collect any other information you so choose to provide.
                    </li>
                </ul>
                <p></p>

                <p class="copy guidelines">
                    <span class="bold">Personal Information We Collect Automatically</span>
                </p>

                <p class="copy">
                    As described below in the "<span class="bold">Cookies and Other Tracking Mechanisms</span>" section, when you
                    visit our Sites or use our Services, we may automatically collect certain Personal Information, including:

                </p><ul class="blackdisc copy">
                    <li>
                        <span class="bold">Device Identifiers.</span> We automatically collect IP address, unique device ID, device
                        type, browser type, location information, and information about your browser and browser language.
                    </li>
                    <li>
                        <span class="bold">Network Activity.</span> We may also collect information related to how you interact with
                        the Services and advertisements, such as page views, links and items clicked and other activity information,
                        referring URL, browsing history, and other similar information. We may use analytics providers and
                        technologies, including cookies, session replay, and similar tools, to collect this information.
                    </li>
                    <li>
                        <span class="bold">Geolocation.</span> We may also collect geolocation information, such as physical
                        location or movements. Additionally, depending on your device settings, if you visit our Sites or use our
                        mobile applications, we may collect geolocation information from your IP address which links to the region
                        you live in.
                    </li>
                </ul>
                <p></p>

                <p class="copy guidelines">
                    <span class="bold">Personal Information We Collect from Other Sources</span>
                </p>

                <p class="copy">
                    We may collect information about you from veterinary providers, or through our affiliates, business partners,
                    and vendors, including from administrators, adjusters, agents, brokers, or other representatives who provide
                    services or products on our behalf. For example, we may collect information about your policies, including
                    coverage or claim information, through these sources. We may also receive information from publicly available
                    sources.
                </p>

                
                <p class="copy">
                </p><h2 id="HowWeUsePersonalInformation" class="bold subHeader">How We Use Personal Information</h2>
                <p></p>
                <p class="copy">
                    We may use the Personal Information we collect for the following purposes:
                </p>
                <p class="copy">
                </p><ul class="blackdisc copy">
                    <li>
                        <span class="bold">Operate Our Business.</span> We use the Personal Information we collect to allow you to
                        maintain your account and otherwise run our day-to-day operations.
                    </li>
                    <li>
                        <span class="bold">Provide You Products and Services.</span> We use the Personal Information we collect to
                        provide you with, renew or modify products and services. We also use this information to maintain your
                        coverage and memberships, including to set up a product or service, service your policy, change your policy,
                        handle a claim, or complete a transaction.
                    </li>
                    <li>
                        <span class="bold">Communicate With You.</span> We use the Personal Information we collect to communicate
                        with you about your use of our Sites and Services, to respond to your inquiries, to provide you with the
                        information and documents you request, and for other customer service purposes. We may also use this
                        information to contact you about your account, or to send you necessary information directly related to the
                        products or services you have requested or our newsletter.
                    </li>
                    <li>
                        <span class="bold">Evaluate and Improve Our Products and Services.</span> We use the Personal Information we
                        collect to evaluate, analyze, improve, and develop our products and Services, including this Site. We also
                        use this information to tailor the content and information that we may send or display to you, to offer
                        location customization and personalized help and instructions, and to otherwise personalize your experiences
                        while using our Services.
                    </li>
                    <li>
                        <span class="bold">Analytics Models to Support our Business.</span> We use the Personal Information we
                        collect in analytics models, including actuarial, underwriting, claims, and loss control models, to
                        facilitate and service our business (e.g., to create new products and features). We may also use this
                        information to conduct actuarial or research studies to maintain and develop our products and Services, and
                        to create new offerings or features. We also use this information to administer surveys and questionnaires,
                        such as for market research or member satisfaction purposes.
                    </li>
                    <li>
                        <span class="bold">Marketing and Advertising.</span> We may use your Personal Information for marketing and
                        promotional purposes, including to send you promotional communications about products, services, features,
                        and options we believe may interest you. We may send communications via e-mail, regular mail or may send
                        push notifications via a mobile device. We may also use your information to serve you advertisements or
                        customized content online.
                    </li>
                    <li>
                        <span class="bold">Inferences.</span> We may use the information we collect to better understand how you
                        access and use our Sites and the products and Services available on our Sites, both on an aggregated and
                        individualized basis.
                    </li>
                    <li>
                        <span class="bold">Find Locations on Request.</span> At your request, we may use your information to obtain
                        your location from the mobile device or the network using your device's Global Positioning System (GPS)
                        functionality, or directly from you. We may use your location information to help you search for information
                        or provide our products or services. If you do not want location information used, you can disable the GPS
                        functionality on your mobile device.
                    </li>
                    <li>
                        <span class="bold">Fraud and Security Purposes.</span> We may use the Personal Information we collect to
                        mitigate fraud and protect Healthy Paws and others. We also use this information to prevent and detect
                        fraudulent, malicious, deceptive, infringements of our policies and contracts and other potential misuse of
                        or illegal activity relating to our products, assets, and Services.
                    </li>
                    <li>
                        <span class="bold">Legal Requirements.</span> We use the Personal Information we collect to investigate,
                        enforce, and apply this Policy and our Terms and Conditions, and to otherwise protect our own rights and
                        interests, such as to resolve any disputes or to respond to requests from law enforcement, court orders,
                        regulators, or other legal processes.
                    </li>
                    <li>
                        <span class="bold">Business Transfers.</span> We may also use the Personal Information we collect and
                        receive to consider and implement mergers, acquisitions, reorganizations, refinancing, and other business
                        transactions, and for the administration of our general business, accounting, recordkeeping, and other legal
                        functions.
                    </li>
                    <li>
                        <span class="bold">Other Operational and Business Purposes.</span> We may use your Personal Information for
                        other operational purposes, including to refer you to our third-party partners as part of a referral
                        program, to comply with contracts related to products or services that we provide to you.
                    </li>
                </ul>
                <p></p>
                <p class="copy">
                    We also may use automated processes and combine or aggregate any of the information we collect through the
                    Services or elsewhere for any of these purposes or for analyzing usage statistics and trends.
                </p>

               
                <p class="copy">
                </p><h2 id="HowWeMayDisclosePersonalInformation" class="bold subHeader">How We May Disclose Personal Information</h2>
                <p></p>
                <p class="copy">
                    When permitted by applicable law, including in cases that require your consent, we may disclose your Personal
                    Information to our affiliates, business partners, vendors and services providers, and others as follows:
                </p>
                <p class="copy">
                </p><ul class="blackdisc copy">
                    <li>
                        <span class="bold">Affiliates and Business Partners.</span> We may disclose the Personal Information we
                        collect with our affiliates, agents and brokers. Healthy Paws also partners with other businesses to offer
                        products and services, and we may disclose your Personal Information to those organizations, including those
                        that play a role in insurance transactions such as independent claims adjusters, and other claims related
                        companies. If required by law, we will obtain consent prior to disclosing Personal Information.
                    </li>
                    <li>
                        <span class="bold">Vendors and Service Providers.</span> We may disclose the Personal Information we collect
                        with vendors and service providers who perform functions on our behalf, such as helping complete
                        transactions and process payments, handling claims, servicing your policy or membership, and engaging in
                        credit reporting. We may also disclose your information to vendors and service providers who provide website
                        hosting, automated processes and analytics, marketing and advertising, email or other communication
                        services, development and research or actuarial studies, customer support, and tax, accounting, and legal
                        services.
                    </li>
                    <li>
                        <span class="bold">Marketing and Advertising Partners.</span> We may also disclose your Personal
                        Information, such as name and contact information, with our marketing and advertising partners to send you
                        content about certain products and Services.
                    </li>
                </ul>
                <p></p>
                <p class="copy">
                    We also may disclose your Personal Information in the following circumstances:
                </p>
                <p class="copy">
                </p><ul class="blackdisc copy">
                    <li>
                        <span class="bold">Business Transfers.</span> As we continue to develop our business, we may buy, merge, or
                        partner with other companies. We may disclose Personal Information as part of those commercial transactions
                        (e.g., mergers, acquisitions, financings, asset sales or transfers, bankruptcy or reorganization or other
                        similar business transactions), as well as in contemplation of such transactions (e.g., due diligence).
                        Where possible we will do so under appropriate confidentiality agreements. Similarly, if all or part of our
                        business, assets, or Sites are merged with or sold to another company, or as part of a bankruptcy
                        proceeding, your Personal Information may be transferred to the surviving or acquiring company.
                    </li>
                    <li>
                        <span class="bold">In Response to Legal Process.</span> Personal Information may be disclosed to third
                        parties, as required by law or subpoena, or if we reasonably believe such action is necessary to comply with
                        the law and the reasonable requests of regulators, law enforcement or other public authorities. We also may
                        disclose the information we collect in order to comply with a judicial proceeding, court order, or other
                        legal process, including responding to national security or law enforcement disclosure requirements.
                    </li>
                    <li>
                        <span class="bold">To Prevent Fraud and Protect Us and Others.</span> We also may disclose the Personal
                        Information we collect from you where we believe it is necessary to investigate, prevent, or take action
                        regarding illegal activities, suspected fraud, situations involving potential threats to the safety of any
                        person, violations of this Policy or our Terms and Conditions, or as evidence in litigation in which we are
                        involved. We may also disclose Personal Information to protect our rights and the rights of others. This may
                        include exchanging information with other companies and organizations for fraud prevention, spam/malware
                        mitigation, and similar purposes.
                    </li>
                    <li>
                        <span class="bold">Aggregate and De-Identified Information.</span> We may disclose aggregate or
                        de-identified information about users with third parties for marketing, advertising, research, or other
                        purposes.
                    </li>
                    <li>
                        <span class="bold">With Your Permission.</span> We may disclose Personal Information in other ways not
                        described above. If we do so, we will notify you and, if necessary, obtain your consent.
                    </li>
                </ul>
                <p></p>

                
                <p class="copy">
                </p><h2 id="HowWeCollectAndUseSocialSecurityNumbers" class="bold subHeader">How We Collect and Use Social Security
                    Numbers</h2>
                <p></p>
                <p class="copy">
                    Healthy Paws may collect Social Security numbers ("SSNs") in the course of our business. We strive to protect
                    the confidentiality and security of SSNs in our possession, custody or control by: (i) limiting access to SSNs
                    and (ii) maintaining reasonable administrative, technical and physical safeguards to protect against the loss,
                    misuse or unlawful disclosure of SSNs. We do not share SSNs for marketing purposes.
                </p>

                
                <p class="copy">
                </p><h2 id="CookiesAndOtherTrackingMechanisms" class="bold subHeader">Cookies and Other Tracking Mechanisms</h2>
                <p></p>
                <p class="copy">
                    We and our third-party service providers use cookies, pixels, tags, and other similar tracking mechanisms to
                    automatically collect information about browsing activity, type of device and similar information within our
                    Services and to target advertising and content across our Services and third-party sites and services. We use
                    this information to, for example, analyze and understand how users access, use and interact with others through
                    our Services, as well to identify and resolve bugs and errors in our Services and to assess, secure, protect,
                    optimize and improve the performance of our Services.
                </p>
                <p class="copy">
                    <span class="bold italic">Cookies.</span> "Cookies" are alphanumeric identifiers we transfer to your device's
                    hard drive through your web browser for tracking purposes. Some cookies allow us to make it easier for you to
                    navigate our Services, while others are used to enable a faster log-in process, support the security and
                    performance of the Services, or allow us to track activity and usage data within our Service.
                </p>
                <p class="copy">
                    <span class="bold italic">Clear GIFs, Pixel Tags, and Other Technologies.</span> In addition to cookies, we may
                    also use pixel tags (sometimes called web beacons or "clear GIFs") to collect information about you and your use
                    of our Services. While cookies are stored locally on your device, pixel tags are embedded invisibly within web
                    pages and online content. We may use these, in connection with our Services to, among other things, track the
                    activities of users, help us manage content and compile usage statistics. We may also use these in HTML e-mails
                    we send, to help us track e-mail response rates, identify when our e-mails are viewed, and track whether our
                    e-mails are forwarded.
                </p>
                <p class="copy">
                    <span class="bold italic">Third-Party Analytics and Tools.</span> We use third party tools, such as Google
                    Analytics, which are operated by third party companies. These third-party analytics companies may collect usage
                    data (using cookies, pixels and similar tools) about our Services in order to provide us with reports and
                    metrics that help us evaluate usage of our Services, improve our Sites, and enhance performance and user
                    experiences. To learn more about Google's privacy practices, please review the Google Privacy Policy at <a href="https://www.google.com/policies/privacy/partners/" target="_blank">https://www.google.com/policies/privacy/partners/</a>. You can also download the Google
                    Analytics Opt-out Browser Add-on to prevent your data from being used by Google Analytics at <a href="https://tools.google.com/dlpage/gaoptout" target="_blank">https://tools.google.com/dlpage/gaoptout</a>.
                </p>
                <p class="copy">
                    <span class="bold italic">Cross-Device Tracking.</span> We and our third-party providers may use the information
                    that we collect about you within our Services and on other third-party sites and services to help us and these
                    third parties to identify other devices that you use (e.g., a mobile phone, tablet, other computer, etc.).
                </p>
                <p class="copy">
                    <span class="bold italic">Targeted Advertising.</span> We work with third parties, such as ad networks, channel
                    partners, mobile ad networks, analytics and measurement services and others ("Advertising Providers") to
                    personalize content and display advertising within our Services. We and our Advertising Providers may use
                    cookies, pixels tags, session replay and other tools to collect information within our Services such as IP
                    address, location information, device ID, cookie and advertising IDs, and other identifiers, as well as browsing
                    information such as web pages, videos and other content accessed by you. We and our Advertising Providers use
                    this information to provide you more relevant ads and content within our Services, and to evaluate the success
                    of such ads and content.
                </p>
                <p class="copy">
                    <span class="bold italic">Do Not Track.</span> We do not currently respond to web browser "Do Not Track"
                    signals.
                </p>


           
                <p class="copy">
                </p><h2 id="YourCookieAndMarketingChoices" class="bold subHeader">Your Cookie and Marketing Choices</h2>
                <p></p>
                <p class="copy">
                    We make available several ways for you to manage choices about your Personal Information, including preferences
                    regarding cookies, advertising, whether you want to receive marketing and promotional emails from us, and
                    choices regarding your account and profile information.
                </p>
                <p class="copy">
                </p><ul class="blackdisc copy">
                    <li>
                        <span class="bold">Cookie Settings.</span> If you wish to prevent cookies from tracking your activity on our
                        Sites or visits across multiple websites, you can set your browser to block certain cookies or notify you
                        when a cookie is set; you can also delete cookies. The "Help" portion of the toolbar on most browsers will
                        tell you how to prevent your device from accepting new cookies, how to have the browser notify you when you
                        receive a new cookie, or how to delete cookies. Visitors to our Sites who disable cookies will be able to
                        browse the Sites, but some features may not function.
                    </li>
                    <li>
                        <span class="bold">Industry Ad Choice Programs.</span> You can also control how participating third-party ad
                        companies use the information that they collect about your visits to our websites and use of our mobile
                        applications, and those of third parties, in order to display more relevant targeted advertising to you. If
                        you are in the U.S., you can obtain more information and opt out of receiving targeted ads from
                        participating third-party ad networks at <a href="https://aboutads.info/choices" target="_blank">aboutads.info/choices</a> (Digital Advertising Alliance). You may also download the DAA
                        AppChoices tool (<a href="https://youradchoices.com/appchoices" target="_blank">https://youradchoices.com/appchoices</a>) in order to help control interest-based
                        advertising on apps on your mobile device.
                    </li>
                    <li>
                        <span class="bold">Marketing Communications.</span> You can opt out of receiving marketing emails from us by
                        using the unsubscribe feature in any such email we send you.
                    </li>
                    <li>
                        <span class="bold">Account and Profile Information.</span> You may access, update, or correct your account
                        and profile information at any time by logging in to your account and updating the Personal Information we
                        maintain. We may keep a copy of your prior information for a period of time, as part of our business records
                        and our backup data.
                    </li>
                </ul>
                <p></p>


                <p class="copy">
                </p><h2 id="ChildrensInformation" class="bold subHeader">Children's Information</h2>
                <p></p>
                <p class="copy">
                    Our Services are not designed for children, and we do not knowingly collect Personal Information from children
                    under the age of thirteen (13). If we learn that we have received information directly from a child who is under
                    the age of 13, we will delete such information from our systems. If you are a parent or legal guardian and you
                    believe we have collected your child's information in violation of applicable law, please contact us using the
                    contact information below.
                </p>


                <p class="copy">
                </p><h2 id="ExternalLinks" class="bold subHeader">External Links</h2>
                <p></p>
                <p class="copy">
                    When you use our Services, you may find links to other websites that we do not own or control. We are not
                    responsible for the privacy practices of these other sites, including their collection of your Personal
                    Information. You should review the terms and conditions and privacy policies of these other sites before
                    providing your information.
                </p>


                <p class="copy">
                </p><h2 id="BlogsAndOtherFeatures" class="bold subHeader">Blogs and Other Features</h2>
                <p></p>
                <p class="copy">
                    We may offer blogs, online forums or other interactive features in connection with our Services that enable you
                    to share information about the Services or other issues of interest. You should be aware that any communications
                    you submit or post to any such interactive features on the Services may be viewable by other participants or
                    users. By submitting or posting to such interactive features you acknowledge and agree that you have no
                    expectation of privacy or confidentiality in the content you submit for such features, whether or not it
                    contains Personal Information about you.
                </p>


                <p class="copy">
                </p><h2 id="ArtificialIntelligence" class="bold subHeader">Artificial Intelligence</h2>
                <p></p>
                <p class="copy">
                    We or our third party service providers may use artificial intelligence (AI) to provide products or services to
                    you,
                    <span style={{textDecoration: 'underline'}}>
                        which may involve the use of your Personal Information from the Sources described herein
                    </span>.
                    We may use AI in connection with our products or services to facilitate and service our business (e.g., assist
                    in underwriting, pricing, claims handling process or data management), as well as to enhance performance and
                    user experience on our websites and applications. The type of AI we use varies based on your relationship with
                    us and by product and service.
                </p>


                <p class="copy">
                </p><h2 id="Security" class="bold subHeader">Security</h2>
                <p></p>
                <p class="copy">
                    We have implemented safeguards designed to protect Personal Information from loss, misuse, and unauthorized
                    access, disclosure, alteration, and destruction. Please be aware that despite our efforts, no data security
                    measures can guarantee security.
                </p>

                <p class="copy">
                </p><h2 id="ChangesToThisPolicy" class="bold subHeader">Changes to This Policy</h2>
                <p></p>
                <p class="copy">
                    This Policy is current as of the Effective Date set forth above. We may change this Policy at any time and from
                    time to time. Any amendments or modifications to this Policy will become effective immediately upon posting. We
                    will let you know of amendments or modifications by appropriate means such as by posting the revised statement
                    on this page with a new "Last Updated" date. Your continued use of any of our Services following the posting of
                    a revised version of this Policy will constitute your acceptance of the revised Policy. If you do not agree with
                    the revised Policy, do not use any of our Services.
                </p>


                <p class="copy">
                </p><h2 id="ContactUs" class="bold subHeader">Contact Us</h2>
                <p></p>
                <p class="copy">
                    If you have questions about this Policy or our privacy practices or our use of AI, please contact us using the
                    contact information provided below.
                </p>
                <p class="copy" style={{margin:'0'}}>
                    <span class="bold">Chubb Group</span>
                </p>
                <p class="copy" style={{margin:'0'}}>Attention: NA Privacy Office</p>
                <p class="copy" style={{margin:'0'}}>202 Hall's Mill Road, P.O. Box 1600</p>
                <p class="copy" style={{margin:'0'}}>Whitehouse Station, NJ 08889-1600</p>
                <p class="copy" style={{margin:'0'}}>Telephone: 1-833-324-9798</p>
                <p class="copy" style={{margin:'0'}}>E-mail: <a href="mailTo:NAPrivacyOffice@chubb.com">NAPrivacyOffice@chubb.com</a>
                </p>


                <p class="copy">
                </p><h2 id="Consent" class="bold subHeader">Consent</h2>
                <p></p>
                <p class="copy">
                    By using the Services or by consenting using a consent mechanism where provided you signify your consent to this
                    Policy and this site's Terms and Conditions. If you do not agree to this Policy or the site's Terms and
                    Conditions, please do not use the Services. The Services are not for use within any country or jurisdiction or
                    by any persons where such use would constitute a violation of law. If this applies to you, you are not
                    authorized to access or use any of the Services.
                </p>

                <h1 class="greenHeader" id="AdditionalNoticeToCaliforniaResidents">Additional Notice to California Residents</h1>
                <p class="copy italic">
                    If you would like to exercise your rights under the California Consumer Privacy Act of 2018, as amended by the
                    California Privacy Rights Act of 2020 ("CCPA"), please visit us at our <a href="https://privacyportal-de.onetrust.com/webform/90614a50-71bc-4b29-ad21-25276f3948c0/23bf8860-3be8-4e0b-b97d-91885c70e8be" target="_blank">Data Subject Request web page</a> or call us at the following toll-free telephone number
                    1-833-324-9798.
                </p>
                <p class="copy italic">
                    You can find Healthy Paw's <a href="#CCPANoticeAtCollection">CCPA Notice at Collection</a> below.
                </p>
                <p class="copy">
                    This section of our Privacy Policy provides additional information for California residents pursuant to the CCPA
                    and applies to
                    "Personal Information" as defined in the CCPA, whether collected online or offline. This section of our Privacy
                    Policy applies
                    to <a href="https://www.healthypawspetinsurance.com" target="_blank">www.healthypawspetinsurance.com</a> and
                    other websites or
                    mobile applications that link to this Privacy Policy (the "<span class="bold">Services</span>"), as well as
                    offline activities where California residents
                    are directed to this section of the Privacy Policy. As used in this section of our Privacy Policy, "Personal
                    Information" means any information that identifies, relates to, describes, is reasonably capable of being
                    associated with, or could reasonably be linked, directly or indirectly, with a particular California resident or
                    household.
                </p>

                <p class="copy guidelines">
                    <span class="bold">Service Provider</span>
                </p>
                <p class="copy">
                    Healthy Paws may sometimes act as a service provider under the CCPA. This means that we collect and use Personal
                    Information on behalf of another company. Where your Personal Information is processed by Healthy Paws acting as
                    a service provider, that other company's privacy policy will explain its privacy practices, and you should
                    submit any request to exercise CCPA rights directly to that company. If you make a request to exercise CCPA
                    rights to Healthy Paws it acts as a service provider under the CCPA, we may be required to disclose your request
                    to the relevant company.
                </p>

                <p class="copy guidelines">
                    <span class="bold">Personal Information Not Covered by this California Section of the Privacy Policy</span>
                </p>
                <p class="copy">
                    There are a number of exemptions from the application of the CCPA. The following sets out some of the categories
                    of Personal Information that are not subject to the CCPA, and therefore are not covered by this California
                    section of the Privacy Policy. Note that other sections of the Privacy Policy may still apply in addition to
                    other privacy notices that we may issue addressing our specific relationship with you, including privacy notices
                    that are sent to individuals.
                </p>
                <p class="copy">
                </p><ul class="blackdisc copy">
                    <li>
                        Health or medical information that we collect and that is subject to the Health Insurance Portability and
                        Accountability Act of 1996 ("<span class="bold">HIPAA</span>"), the California Confidentiality of Medical
                        Information Act or the Health Information Technology for Economic and Clinical Health Act.
                    </li>
                    <li>
                        Information we collect in connection with the issuance of financial products or services to you that are to
                        be used primarily for your personal, family, or household purposes and that is subject to the
                        Gramm-Leach-Bliley Act ("<span class="bold">GLBA</span>") or the California Financial Information Privacy
                        Act. For example, where we provide you with a personal insurance policy, or where we handle a claim from you
                        as an individual. Note that this exclusion may not apply to all of your Personal Information, including to
                        personal information collected before you become a customer. Healthy Paws provides a separate GLBA privacy
                        notice to certain individual consumers as required under applicable laws and regulations.
                    </li>
                    <li>
                        Information we collect and provide for use that is subject to the Fair Credit Reporting Act.
                    </li>
                    <li>
                        Information we collect as a motor vehicle record and that is subject to the Driver's Privacy Protection Act
                        of 1994.
                    </li>
                    <li>
                        Publicly available information from government records, and information we have a reasonable basis to
                        believe is lawfully made available to the general public by you or by widely distributed media, or by a
                        person to whom you have disclosed the information and not restricted it to a specific audience.
                    </li>
                    <li>
                        Deidentified or aggregated information.
                    </li>
                </ul>
                <p></p>

                <p class="copy">
                </p><h2 id="CCPANoticeAtCollection" class="bold subHeader italic">California Notice At Collection</h2>
                <p></p>
                <p class="copy guidelines">
                    <span class="bold">Categories of Personal Information Collected &amp; Disclosed </span>
                </p>
                <p class="copy">
                    The following identifies the categories of Personal Information we may collect about you (and may have collected
                    in the prior 12 months). Note that our collection, use and disclosure of Personal Information about you will
                    vary depending upon the circumstances and nature of our interactions or relationship with you. Depending on how
                    you use our Services, we may collect the following categories of Personal Information:
                </p>
                <p class="copy">
                </p><ul class="blackdisc copy">
                    <li>
                        <span class="bold">Identifiers</span>, such as real name, alias, address, email address, date of birth,
                        policy number, salary information, social security number, driver's license number, other government
                        identifiers, and tax ID.
                    </li>
                    <li>
                        <span class="bold">Online Identifiers</span>, such as unique personal identifiers, device IDs, ad IDs, IP
                        addresses, and cookie data.
                    </li>
                    <li>
                        <span class="bold">Customer or Claimant Records</span>, such as paper or electronic customer or claimant
                        records containing Personal Information, as well as information provided by an insurance broker/agent or
                        reinsurer for underwriting purposes and information included in a list of claims, such as name, signature,
                        address, telephone number, social security number, passport number, driver's license or state identification
                        card number, insurance policy number, bank account number, payment card number, and records of personal
                        property, products or services purchased or obtained.
                    </li>
                    <li>
                        <span class="bold">Financial Information</span>, such as your bank account or credit card number and other
                        payment details.
                    </li>
                    <li>
                        <span class="bold">Usage Data</span>, such as Internet or other electronic network activity information
                        regarding a California resident's interaction with portals, Internet websites, applications, or
                        advertisements, including, but not limited to, browsing history, clickstream data, search history and
                        content of public posts.
                    </li>
                    <li>
                        <span class="bold">Geolocation Data</span>, such as physical location or movements.
                    </li>
                    <li>
                        <span class="bold">Audio, Video and Other Electronic Data</span>, such as audio information including call
                        recordings, video and photographs.
                    </li>
                    <li>
                        <span class="bold">Inferences and Preferences</span>, such as inferences drawn from any of the information
                        described in this section about a consumer including inferences reflecting the consumer's preferences,
                        characteristics, behavior and abilities.
                    </li>
                    <li>
                        <span class="bold">Sensitive Personal Information</span>, such as social security number, driver's license
                        number, racial or ethnic origin, citizenship or immigration status, religious or philosophical beliefs,
                        medical condition, and physical or mental disability.
                    </li>
                </ul>
                <p></p>

                <p class="copy guidelines">
                    <span class="bold">Sources of Personal Information</span>
                </p>
                <p class="copy">
                    We generally collect Personal Information from the following categories of sources:
                </p>
                <p class="copy">
                </p><ul class="blackdisc copy">
                    <li>
                        Directly from you and automatically;
                    </li>
                    <li>
                        Our affiliates;
                    </li>
                    <li>
                        Brokers and agents;
                    </li>
                    <li>
                        Veterinary providers; and
                    </li>
                    <li>
                        Our vendors and service providers (e.g., third party administrators).
                    </li>
                </ul>
                <p></p>


                <p class="copy guidelines">
                    <span class="bold">Purposes for Collecting and Disclosing Personal Information</span>
                </p>
                <p class="copy">
                    As described in the "<span class="bold">How We Use Personal Information</span>" section above, in general, we
                    collect and otherwise process the personal information we collect for the following business or commercial
                    purposes:
                </p>
                <p class="copy">
                </p><ul class="blackdisc copy">
                    <li>
                        Operate our business;
                    </li>
                    <li>
                        Provide you products and services;
                    </li>
                    <li>
                        Communicate with you;
                    </li>
                    <li>
                        Evaluate and improve our products and services;
                    </li>
                    <li>
                        Analytics models to support our business;
                    </li>
                    <li>
                        Marketing and advertising;
                    </li>
                    <li>
                        Inferences;
                    </li>
                    <li>
                        Find locations on request;
                    </li>
                    <li>
                        Fraud and security purposes;
                    </li>
                    <li>
                        Legal requirements;
                    </li>
                    <li>
                        Business transfers; and
                    </li>
                    <li>
                        Other operational and business purposes.
                    </li>
                </ul>
                <p></p>

                <p class="copy guidelines">
                    <span class="bold">Sensitive Personal Information</span>
                </p>
                <p class="copy">
                    Notwithstanding the purposes described above, we do not collect, use, or disclose "sensitive personal
                    information" beyond the purposes authorized by the CCPA. Accordingly, we only use and disclose sensitive
                    personal information as reasonably necessary and proportionate: (i) to perform our services requested by you;
                    (ii) to help ensure security and integrity, including to prevent, detect, and investigate security incidents;
                    (iii) to detect, prevent and respond to malicious, fraudulent, deceptive, or illegal conduct; (iv) to verify or
                    maintain the quality and safety of our services; (v) for compliance with our legal obligations; (vi) to our
                    service providers who perform services on our behalf; and (vii) for purposes other than inferring
                    characteristics about you.
                </p>

                <p class="copy guidelines">
                    <span class="bold">Retention of Personal Information</span>
                </p>
                <p class="copy">
                    We retain the Personal Information we collect only as reasonably necessary for the purposes described in this
                    Privacy Policy or otherwise disclosed to you at the time of collection. For example, we will retain certain
                    identifiers for as long as it is necessary to comply with our tax, accounting and recordkeeping obligations, to
                    administer certain policies and coverage, and for research, development and safety purposes, as well as an
                    additional period of time as necessary to protect, defend or establish our rights, defend against potential
                    claims, and to comply with our legal obligations. From time to time, we may also deidentify your Personal
                    Information, retain it and use it for a business purpose in compliance with CCPA.
                </p>

                <p class="copy guidelines">
                    <span class="bold">Disclosure of Personal Information to Third Parties and Other Recipients</span>
                </p>
                <p class="copy">
                    The categories of Personal Information we may have disclosed for a business purpose in the preceding twelve (12)
                    months include: identifiers, online identifiers, customer records, financial information, usage data,
                    geolocation data, audio, video, and other electronic data, inferences, and sensitive personal information.
                </p>
                <p class="copy">
                    The categories of third parties and other recipients to whom we may disclose personal information for a business
                    purpose may include:
                </p>
                <p class="copy">
                </p><ul class="blackdisc copy">
                    <li>
                        Affiliates and business partners;
                    </li>
                    <li>
                        Vendors and service providers;
                    </li>
                    <li>
                        Acquirers of business assets;
                    </li>
                    <li>
                        Advisors, auditors, consultants, and representatives;
                    </li>
                    <li>
                        Agents and brokers;
                    </li>
                    <li>
                        Reinsurers;
                    </li>
                    <li>
                        Regulators, government entities, and law enforcement;
                    </li>
                    <li>
                        Operating systems and platforms; and
                    </li>
                    <li>
                        Others as required by law.
                    </li>
                </ul>
                <p></p>
                <p class="copy">
                    Additionally, the CCPA defines "sale" as disclosing or making available personal information to a third-party in
                    exchange for monetary or other valuable consideration, and "sharing" includes disclosing or making available
                    personal information to a third-party for purposes of cross-contextual behavioral advertising. While we do not
                    "sell" Personal Information, we may "share" the following categories of Personal Information: online
                    identifiers, and usage data. We disclose this information to third-party advertising networks, analytics
                    providers, and social networks for purposes of marketing and advertising. We do not sell or share "sensitive
                    personal information," nor do we sell or share any Personal Information about individuals who we know are under
                    sixteen (16) years old.
                </p>

                <p class="copy guidelines">
                    <span class="bold">Rights Regarding Your Personal Information</span>
                </p>
                <p class="copy">
                    The CCPA provides California residents with specific rights regarding Personal Information. This section
                    describes your rights under the CCPA and explains how to exercise those rights. Subject to certain exceptions,
                    California consumers have the right to make the following requests:
                </p>
                <p class="copy">
                    <span class="bold italic">Right to Know</span>. With respect to the Personal Information we have collected about
                    you in the prior (twelve) 12 months, you have the right to request from us (up to twice per year and subject to
                    certain exemptions and carveouts):
                </p>
                <p class="copy">
                </p><ul class="blackdisc copy">
                    <li>
                        The categories of Personal Information we collected about you;
                    </li>
                    <li>
                        The sources from which we have collected that Personal Information;
                    </li>
                    <li>
                        Our business or commercial purpose for collecting, selling, or sharing that Personal Information;
                    </li>
                    <li>
                        The categories of third parties to whom we have disclosed that Personal Information; and
                    </li>
                    <li>
                        A copy of the specific pieces of your Personal Information we have collected.
                    </li>
                </ul>
                <p></p>

                <p class="copy">
                    <span class="bold italic">Right to Correct</span>. Subject to certain restrictions, you have the right to
                    request that we correct inaccuracies in your Personal Information.
                </p>

                <p class="copy">
                    <span class="bold italic">Right to Delete</span>. Subject to certain conditions and exceptions, you have the
                    right to request deletion of your Personal Information that we have collected about you.
                </p>

                <p class="copy">
                    <span class="bold italic">Right to Opt-Out</span>. You have the right to opt-out of "sales" and "sharing" of
                    your Personal Information, as those terms are defined under the CCPA. While we do not "sell" Personal
                    Information, our use of certain third-party analytics and advertising cookies may constitute "sharing" under the
                    CCPA. To exercise your right to opt-out of the "sharing" of your Personal Information, please use the <span class="italic">Do Not Sell or Share My Personal Information</span> link at the bottom of our Site.
                </p>
                <p class="copy">
                    You also have the right to opt-out of "sales" and "sharing" of your Personal Information through the use of an
                    opt-out preference signal. If our Site detects that your browser or device is transmitting an opt-out preference
                    signal, such as the "global privacy control" - or GPC - signal, we will opt that browser or device out of
                    cookies on our Site that result in a "sale" or "sharing" of your Personal Information. If you come to our Site
                    from a different device or from a different browser on the same device, you will need to opt-out, or use an
                    opt-out preference signal, for that browser and/or device as well.
                </p>

                <p class="copy">
                    <span class="bold italic">Right to Limit Use and Disclosure of Sensitive Personal Information</span>. We do not
                    engage in uses or disclosures of Personal Information that would trigger the <span class="italic">right to limit
                        use of sensitive personal information</span> under the CCPA.
                </p>

                <p class="copy">
                    <span class="bold italic">Right to Non-Discrimination</span>. We will not discriminate against you for
                    exercising any of the rights described in this section.
                </p>

                <p class="copy guidelines">
                    <span class="bold">Exercising Your Rights</span>
                </p>
                <p class="copy">
                    If you are a California resident and would like to exercise your CCPA rights, you may do so via any of the
                    methods described below:
                </p>
                <p class="copy">
                </p><ul class="blackdisc copy" style={{paddingLeft:'30px'}}>
                    <li>
                        Accessing our <a href="https://privacyportal-de.onetrust.com/webform/90614a50-71bc-4b29-ad21-25276f3948c0/23bf8860-3be8-4e0b-b97d-91885c70e8be" target="_blank">Data Subject Request</a> web page; or
                    </li>
                    <li>
                        Calling us at 1-833-324-9798
                    </li>
                </ul>
                <p></p>
                <p class="copy">
                    <span class="bold italic">Authorized Agent</span>. You may designate someone as an authorized agent to submit
                    requests and act on your behalf. Authorized agents will be required to provide proof of their authorization in
                    their first communication with us, and we may also require that you directly verify your identity and the
                    authority of your authorized agent.
                </p>
                <p class="copy">
                    Businesses operating as an authorized agent on behalf of a California resident must provide both of the
                    following:
                </p>
                <p class="copy">
                </p><ul class="blackdisc copy"  style={{paddingLeft:'15px'}}>
                    <li>
                        (1) Certificate of good standing with its state of organization; and
                    </li>
                    <li>
                        (2) A written authorization document, signed by the California resident, containing the California
                        resident's name, address, telephone number, and valid email address, and expressly authorizing the business
                        to act on behalf of the California resident.
                    </li>
                </ul>
                <p></p>
                <p class="copy">
                    Individuals operating as an authorized agent on behalf of a California resident must provide a written
                    authorization document, signed by the California resident, containing the California resident's name, address,
                    telephone number, and valid email address, and expressly authorizing the individual to act on behalf of the
                    California resident.
                </p>
                <p class="copy">
                    We reserve the right to reject (1) authorized agents who have not fulfilled the above requirements, or (2)
                    automated CCPA requests where we have reason to believe the security of the requestor's personal information may
                    be at risk.
                </p>
                <p class="copy">
                    <span class="bold italic">Verification</span>. Before responding to your request, we must first verify your
                    identity using the Personal Information you recently provided to us. The information we need in order to verify
                    your identity differs depending on the request made and our relationship with you, and might include (as
                    applicable) your name, the email address you regularly use to interact with us, your phone number, your date of
                    birth, and, if available, your policy number. We will take steps to verify your request by matching the
                    information provided by you with the information we have in our records. In some cases, we may request
                    additional information to verify your identity, or where necessary to process your request. In some cases, we
                    may also carry out checks, including with third party identity verification services, to verify your identity
                    before taking any action with your Personal Information. If we are unable to verify your identity after a good
                    faith attempt, we may deny the request and, if so, will explain the basis for the denial.
                </p>
                <p class="copy ArtificialIntelligence">
                    <span class="bold">Artificial Intelligence</span>
                </p>
                <p class="copy">
                    We or our third party service providers may use artificial intelligence (AI) to provide products or services to
                    you,
                    <span style={{textDecoration: 'underline'}}>
                        which may involve the use of your Personal Information from the Sources described herein
                    </span>.
                    We may use AI in connection with our products or services to facilitate and service our business (e.g., assist
                    in underwriting, pricing, claims handling process or data management), as well as to enhance performance and
                    user experience on our websites and applications. The type of AI we use varies based on your relationship with
                    us and by product and service.
                </p>
                <p class="copy guidelines">
                    <span class="bold">Contact Us</span>
                </p>
                <p class="copy">
                    If you have any questions about this section of the Privacy Policy, our privacy practices, or our use of AI, or
                    if you wish to exercise your rights under California law, please contact us at:
                </p>
                <p class="copy" style={{margin:'0'}}>
                    <span class="bold">Chubb Group</span>
                </p>
                <p class="copy" style={{margin:'0'}}>Attention: NA Privacy Office</p>
                <p class="copy" style={{margin:'0'}}>202 Hall's Mill Road, P.O. Box 1600</p>
                <p class="copy" style={{margin:'0'}}>Whitehouse Station, NJ 08889-1600</p>
                <p class="copy" style={{margin:'0'}}>Telephone: 1-833-324-9798</p>
                <p class="copy" style={{margin:'0'}}>E-mail: <a href="mailTo:NAPrivacyOffice@chubb.com">NAPrivacyOffice@chubb.com</a>
                </p>
                


            </div>
        )

    }
}

export default PrivacyPolicyPopup;
